import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Compact pagination: « ‹ 1 … 29 [30] 31 … 56 › » — first, last and a small window
// around the current page, so long lists don't render every page number.
const Pagination = ({ page, totalPages, onChange }) => {
  if (!totalPages || totalPages <= 1) return null;
  const delta = 1;
  const range = [];
  for (let i = Math.max(1, page - delta); i <= Math.min(totalPages, page + delta); i++) range.push(i);

  const items = [];
  if (range[0] > 1) { items.push(1); if (range[0] > 2) items.push('…'); }
  items.push(...range);
  const last = range[range.length - 1];
  if (last < totalPages) { if (last < totalPages - 1) items.push('…'); items.push(totalPages); }

  return (
    <div className="flex justify-center items-center gap-2 p-4 border-t border-white/5 flex-wrap">
      <button onClick={() => onChange(Math.max(1, page - 1))} disabled={page === 1} className="pagination-btn" data-testid="prev-page">
        <ChevronLeft size={18} />
      </button>
      {items.map((it, i) => it === '…'
        ? <span key={`e${i}`} className="px-2 text-[#6B7280] select-none">…</span>
        : <button key={it} onClick={() => onChange(it)} className={`pagination-btn ${page === it ? 'active' : ''}`}>{it}</button>
      )}
      <button onClick={() => onChange(Math.min(totalPages, page + 1))} disabled={page === totalPages} className="pagination-btn" data-testid="next-page">
        <ChevronRight size={18} />
      </button>
    </div>
  );
};

export default Pagination;
